import { render, staticRenderFns } from "./OtaList.vue?vue&type=template&id=55280356&scoped=true"
import script from "./OtaList.vue?vue&type=script&lang=js"
export * from "./OtaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55280356",
  null
  
)

export default component.exports